import * as modalTypes from '../../constaints/modal';
import { modalAction, getType } from '../../redux/actions';

const initialState = {
    modaltype: '',
    title: '',
    button1: 'Close',
    button2: 'OK',
    isOk: false,
    size: "",
    content: '',
    component: null,
    componentContent: null,
}

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case modalTypes.MODAL_CHANGE: case getType(modalAction.modalChange): {
            const { type, title, content, button1, button2, componentContent, size } = action.payload;
            return {
                ...state,
                modaltype: type,
                title: title,
                content: content,
                button1: button1,
                button2: button2,
                componentContent,
                size
            };
        }

        case modalTypes.MODAL_ISOK: case getType(modalAction.modalIsOk): {
            return {
                ...state,
                isOk: true,
            }
        }
        case modalTypes.MODAL_RESET: case getType(modalAction.modalReset): {
            return {
                ...state,
                isOk: false,
            }
        }

        case modalTypes.MODAL_COMPONENT: case getType(modalAction.modalComponent): {
            return {
                ...state,
                component: action.payload,
            }
        }

        case getType(modalAction.modalComponentContent): {
            return {
                ...state,
                componentContent: action.payload,
            }
        }

        default: return state;
    }
}

export default modalReducer;
